export default __webpack_public_path__ + "static/media/7.61de78ad.jpg";